import { c as _c } from "react/compiler-runtime";
import { ReactNode, useState } from 'react';
import Icon from '../../../../common/base/Icon';
import Text from '../../../../common/base/Text';
import { Div } from '../../../../common/helpers/StyledUtils';
import Link from '../../../../common/base/Link';
import JSONBrowser from '../../../../common/JSONBrowser';
import { StyledCard } from '../../../../common/base/Card';
interface CreatedResourceDataProps {
  waiting_label: string;
  status_label: string;
  created_resource: unknown | null;
  alt_action?: ReactNode;
}
const CreatedResourceData: React.FC<CreatedResourceDataProps> = t0 => {
  const $ = _c(24);
  const {
    waiting_label,
    status_label,
    created_resource,
    alt_action
  } = t0;
  const [is_open, setIsOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] !== alt_action || $[1] !== created_resource || $[2] !== is_open || $[3] !== status_label || $[4] !== waiting_label) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const formatted_resource = JSON.stringify(created_resource, null, 2) ?? "{}";
      if (!created_resource) {
        let t3;
        if ($[7] !== waiting_label) {
          t3 = <Text muted={true} shimmering={true}>{waiting_label}</Text>;
          $[7] = waiting_label;
          $[8] = t3;
        } else {
          t3 = $[8];
        }
        t2 = t3;
        break bb0;
      }
      let t3;
      if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
          direction: "column",
          gap: 2
        };
        $[9] = t3;
      } else {
        t3 = $[9];
      }
      let t4;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
          align: "center",
          justify: "space-between",
          gap: 2
        };
        $[10] = t4;
      } else {
        t4 = $[10];
      }
      const t5 = is_open ? "chevron_up" : "chevron_down";
      let t6;
      if ($[11] !== is_open) {
        t6 = () => setIsOpen(!is_open);
        $[11] = is_open;
        $[12] = t6;
      } else {
        t6 = $[12];
      }
      let t7;
      if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <Icon icon="check" />;
        $[13] = t7;
      } else {
        t7 = $[13];
      }
      let t8;
      if ($[14] !== status_label || $[15] !== t5 || $[16] !== t6) {
        t8 = <Link neutral={true} no_underline={true} icon={t5} onClick={t6}>{t7} {status_label}</Link>;
        $[14] = status_label;
        $[15] = t5;
        $[16] = t6;
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      let t9;
      if ($[18] !== alt_action || $[19] !== is_open) {
        t9 = !is_open && alt_action ? <Div>{alt_action}</Div> : null;
        $[18] = alt_action;
        $[19] = is_open;
        $[20] = t9;
      } else {
        t9 = $[20];
      }
      let t10;
      if ($[21] !== t8 || $[22] !== t9) {
        t10 = <Div flex={t4}>{t8}{t9}</Div>;
        $[21] = t8;
        $[22] = t9;
        $[23] = t10;
      } else {
        t10 = $[23];
      }
      t1 = <Div flex={t3}>{t10}{is_open && <StyledCard w={100} m={{
          t: 2
        }} p={3}><JSONBrowser json={JSON.parse(formatted_resource)} /></StyledCard>}</Div>;
    }
    $[0] = alt_action;
    $[1] = created_resource;
    $[2] = is_open;
    $[3] = status_label;
    $[4] = waiting_label;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return t1;
};
export default CreatedResourceData;